import { Upload } from 'lucide-react'

import { Banner } from '@/components/ui/banner'
import { Button } from '@/components/ui/button'

/** The one step where the claim stops moving until the customer does something. */
export function NeedsInputCard() {
  return (
    <Banner
      variant="warning"
      small
      className="mt-2.5"
      action={
        <Button size="sm">
          <Upload />
          Upload photos
        </Button>
      }
    >
      <span className="font-semibold">Jane asked for two more photos.</span> She needs the rear bumper and the
      other vehicle&apos;s plate before she can finish the estimate.
    </Banner>
  )
}
